import React, { useMemo } from "react";
import useForm from "../../../Hooks/useForm";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";
import { FORM_PROMO, DIAS } from "../../../Constants/Admin";
import { PROMO_ITEMS } from "../../../Constants/PromoItems";
import { FormPromoScheme } from "../../../Models/Schemas/form-promo";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import Input from "../../Elements/Input/Input";
import Button from "../../Elements/Button/Button";
import { Select, TextArea, Switch, Campo } from "./Campos";

const FormPromo = ({ promo, cerrar }) => {
  const showToast = useToast();
  const { guardarPromo, guardando } = useStore();

  const initialValues = useMemo(
    () =>
      promo
        ? {
            dia: promo.dia,
            descripcion: promo.descripcion || "",
            precio: promo.precio == null ? "" : String(promo.precio),
            incluye: promo.incluye || [],
            activa: promo.activa !== false,
          }
        : FORM_PROMO,
    [promo]
  );

  const { values, errors, touched, handleChange, handleBlur, setFieldValue, isValid } =
    useForm(initialValues, FormPromoScheme);

  const err = (key) => setErrorFormSimpleUtil(errors, touched, key);

  // Se pueden repetir (ej. 2 pizzas): click agrega, la X quita
  const agregarItem = (k) => setFieldValue("incluye", [...values.incluye, k].slice(0, 6));
  const quitarItem = (idx) => setFieldValue("incluye", values.incluye.filter((_, i) => i !== idx));

  const submit = async () => {
    if (!isValid) return;
    const body = {
      dia: values.dia,
      descripcion: values.descripcion.trim(),
      precio: Number(values.precio),
      incluye: values.incluye,
      activa: values.activa,
    };
    const r = await guardarPromo(body, promo?.promoId);
    showToast(r.ok ? "success" : "error", r.ok ? (promo ? "Promo actualizada ✅" : "Promo creada 🔥") : r.message);
    if (r.ok) cerrar();
  };

  return (
    <form
      className="pp-form"
      onSubmit={(e) => {
        e.preventDefault();
        submit();
      }}
    >
      <div className="pp-form-fila">
        <Select
          label="Día"
          value={values.dia}
          onChange={(v) => setFieldValue("dia", v)}
          opciones={DIAS.map((d) => ({ value: d, label: d }))}
        />
        <Input
          label="Precio"
          value={values.precio}
          placeholder="Ej. 239"
          inputMode="decimal"
          onChange={handleChange("precio")}
          onBlur={handleBlur("precio")}
          error={err("precio")}
          maxLength={8}
        />
      </div>

      <TextArea
        label="¿Qué incluye?"
        value={values.descripcion}
        placeholder="Ej. Pizza familiar tradicional + aros de cebolla + refresco 2L"
        onChange={(v) => setFieldValue("descripcion", v)}
        onBlur={handleBlur("descripcion")}
        error={err("descripcion")}
        maxLength={200}
      />

      <Campo label="Fotos en la tarjeta “Promo de hoy”" ayuda="Toca para agregar (puedes repetir, ej. 2 pizzas). Máximo 6.">
        <div className="pp-promo-items">
          {values.incluye.length === 0 && <span className="pp-vacio-inline">Sin fotos</span>}
          {values.incluye.map((k, i) => (
            <span key={`${k}-${i}`} className="pp-promo-item activo">
              {PROMO_ITEMS[k] && <img src={PROMO_ITEMS[k].img} alt="" />}
              {PROMO_ITEMS[k]?.label || k}
              <button type="button" onClick={() => quitarItem(i)} aria-label={`Quitar ${k}`}>
                <i className="bi bi-x" />
              </button>
            </span>
          ))}
        </div>
        <div className="pp-promo-items pp-promo-catalogo">
          {Object.entries(PROMO_ITEMS).map(([k, item]) => (
            <button
              key={k}
              type="button"
              className="pp-promo-item"
              onClick={() => agregarItem(k)}
              disabled={values.incluye.length >= 6}
            >
              <img src={item.img} alt="" />+ {item.label}
            </button>
          ))}
        </div>
      </Campo>

      <Switch
        label={values.activa ? "Activa (se muestra en la página)" : "Apagada (oculta)"}
        checked={values.activa}
        onChange={(v) => setFieldValue("activa", v)}
      />

      <div className="pp-form-acciones">
        <Button text="Cancelar" color="gray" action={cerrar} padding />
        <Button
          text={guardando ? "Guardando…" : "Guardar"}
          color="red"
          fill
          action={submit}
          disabled={!isValid || guardando}
          padding
        />
      </div>
    </form>
  );
};

export default FormPromo;
